import AppFormDetail from "@/controllers/application_form/app-form-detail";
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";
import store from "@/store";

export default {
  extends: AppFormDetail,

  data() {
    return {
      appTypeText: CONFIG.APPLICATION.TYPE_TXT,
      appFormType: CONFIG.APPLICATION.TYPE,
      parentRequired: CONFIG.PARENT_REQUIRED,
      studentRequired: CONFIG.STUDENT_REQUIRED,
      urlPrefix: CONFIG.APPLICATION.URL_PREFIX,
    };
  },

  methods: {
    getCampusGradeName() {
      return axios.get('getAcademicYearCampusGradeName', {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        let $defaultSelectOption = [{
          "id": 0,
          "text": "Select Grade Name"
        }];
        this.campusGradeArr = $defaultSelectOption.concat(res.data);
      }).catch((error) => {
        if (error?.response?.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    async getItemsList () {
      if (this.appFormData.type == null) {
        this.isLoading = false;
        return;
      }
      let formType = this.appFormData.type;
      if (formType == this.appFormType.PARENT) {
        await axios.get('item/list/' + this.itemTypes.PARENT)
                  .then(res => {
                    let parentItems = res.data.filter( item =>
                      this.isInItemArr(item.id) || this.parentRequired.includes(item.key)
                    );
                    this.parentFormItemsArr = parentItems;
                    this.isLoading = false;
                  }).catch((error) => {
                    if (error?.response?.status == 401) {
                      this.$store.commit('logout');
                      window.location.replace('login');
                    }
                    this.isLoading = false;
                  });
      }
      await axios.get('item/list/' + this.itemTypes.STUDENT)
                .then(res => {
                  let studentItems = res.data.filter( item =>
                    this.isInItemArr(item.id) || this.studentRequired.includes(item.key)
                  );
                  this.studentFormItemsArr = studentItems;
                  this.isLoading = false;
                }).catch((error) => {
                  if (error?.response?.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                  }
                  this.isLoading = false;
                });
      await axios.get('item/list/' + this.itemTypes.ADDITIONAL)
                .then(res => {
                  let additeonalItems = res.data.filter( item =>
                    this.isInItemArr(item.id)
                  );
                  this.additionalFormItemsArr = additeonalItems;
                  this.isLoading = false;
                }).catch((error) => {
                  if (error?.response?.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                  }
                  this.isLoading = false;
                });
    },
  },
}
